<template>

  <div class="norte">

    <div class="fila d-flex flex-row justify-content-center">
      <rombo class="comun" color="#005F73" :border="true">
        <a class="box-link" v-html="this.team[persona.id].caracteristica[0][this.$i18n.locale()]"></a>
      </rombo>
    </div>

    <div class="fila d-flex flex-row justify-content-center">
      <rombo class="comun" color="transparent !important;">
      </rombo>
      <rombo class="comun" color="#005F73" :border="true">
        <a class="box-link" v-html="this.team[persona.id].caracteristica[1][this.$i18n.locale()]"></a>
      </rombo>
    </div>

    <div class="fila d-flex flex-row justify-content-center medio">
      <rombo class="principal" color="#F18800" :border="true" v-on:click.native="goBack"
              >
        <img :src="persona.fotos.front"
             :alt="persona.name"/>
        <span v-b-tooltip.hover :title="$t('utils.back')" class="arrow-back">
          <font-awesome-icon icon="arrow-left"/>
        </span>
      </rombo>

      <rombo class="comun" color="transparent !important;">
      </rombo>
    </div>

    <div class="fila d-flex flex-row justify-content-center">
      <rombo class="comun" color="transparent !important;">
      </rombo>
      <rombo class="comun" color="transparent !important;">
      </rombo>
      <rombo class="comun" color="#F18800" :border="true">
        <a class="box-link" v-html="this.team[persona.id].description[this.$i18n.locale()]"></a>
      </rombo>
    </div>

    <div class="fila d-flex flex-row justify-content-center">
      <rombo class="comun" color="transparent !important;">
      </rombo>
      <rombo class="comun" color="#005F73" :border="true">
        <a class="box-link" v-html="this.team[persona.id].caracteristica[2][this.$i18n.locale()]"></a>
      </rombo>
    </div>

    <div class="fila d-flex flex-row justify-content-center">
      <rombo class="comun" color="#005F73" :border="true">
        <a class="box-link" v-html="this.team[persona.id].caracteristica[3][this.$i18n.locale()]"></a>
      </rombo>
    </div>

  </div>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

  import Rombo from '../components/Rombo'
  import foto from '../assets/images/home/logoWhite.svg'
  import team from '../config/team'

  export default {
    components: { Rombo, FontAwesomeIcon },
    name: 'Expanded',
    data () {
      return {
        foto,
        team
      }
    },
    props: {
      persona: {
        type: Object,
        default: null
      }
    },
    computed: {
    },
    methods: {
      goBack: function () {
        this.$emit('showingOpen', 'goBack')
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">

  @keyframes arrow-back {
    0%   { left: -30px; }
    10%   { left: -29px; }
    20%   { left: -28px; }
    30%   { left: -27px; }
    40%   { left: -26px; }
    50%   { left: -25px; }
    60%   { left: -26px; }
    70%   { left: -27px; }
    80%   { left: -28px; }
    90%   { left: -29px; }
    100%   { left: -30px; }

  }

  .arrow-back {
    position: absolute;
    left: -30px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    z-index: 999;
    color: #fff;
    font-size: 25px;
    animation: arrow-back 1s infinite;
  }

  .container-center{
    justify-content: center;
    align-items: center
  }

  .box-link {
    font-family: "Open Sans", sans-serif;
    font-size: 0.7rem;
    color: #FFFFFF;

    @media (min-width: 1400px) {
      font-size: 1rem;
    }
  }

  img{
    width: 228px;
    top: -1px;
    left: 9px;
    position: absolute;
    @media (min-width: 1400px) {
      width: 310px;
      top: 18px;
      left: 19px;
    }
  }


  .tope{
   margin-top: -38px;
  }

  .principal{
    width: 239px;
    height: 239px;
    background-repeat:no-repeat;
    background-size: contain;
    background-position: center;
    cursor: pointer;
    z-index: 999;

    @media (min-width: 1400px) {
      width: 338px;
      height: 338px;
    }
  }

  .medio{
    margin-top: -96px !important;
    margin-bottom: -181px;

    @media (min-width: 1400px) {
      margin-top: -134px !important;
      margin-bottom: -255px;
    }
  }

  .comun{
    width: 120px;
    height: 120px;
    background-repeat:no-repeat;
    background-size: contain;
    background-position: center;
    position: center;
    line-height: 1.3rem;

    // Extra large devices (large desktops, 1200px and up)
    @media (min-width: 1400px) {
      width: 170px;
      height: 170px;
    }
  }


  .norte{
    margin-left: 8px;
  }

  .fila + .fila {
    margin-top: -36px;

    @media (min-width: 1400px) {
      margin-top: -50px;
    }
  }
  .rom + .rom {
    margin-left: 48px;
    @media (min-width: 1400px) {
      margin-left: 68px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/RomboTeamOeste.vue